import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimelineContainer } from '../models/timeline-container.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TimelineService {
  private apiUrl = environment.apiUrl + environment.reportPath;

  constructor(private http: HttpClient) {}

  getContainerTimelineEvents(containerId: number): Observable<TimelineContainer> {
    return this.http.get<TimelineContainer>(
      `${this.apiUrl}${environment.containerPath}${environment.timelinePath}/${containerId}`,
    );
  }

  getMaintenanceRecordTimelineEvents(MaintenanceRecordId: number): Observable<TimelineContainer> {
    return this.http.get<TimelineContainer>(
      `${this.apiUrl}${environment.maintenanceRecordPath}${environment.timelinePath}/${MaintenanceRecordId}`,
    );
  }

  getMaintenanceRecordEvents(MaintenanceRecordId: number): Observable<TimelineContainer> {
    return this.http.get<TimelineContainer>(
      `${this.apiUrl}${environment.maintenanceRecordPath}/${MaintenanceRecordId}`,
    );
  }
}
